import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { DocumentSummaryModel } from '../../cmg-1003/models';

function createInitialState(): DocumentSummaryModel {
  return <DocumentSummaryModel>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'cmg-1003-document-summary-store' })
export class Cmg1003DocumentSummaryStore extends Store<DocumentSummaryModel> {
  constructor() {
    super(createInitialState());
  }
}
